module.exports = __webpack_public_path__ + "static/media/Want-to-Know-More.41736792.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/SHS-ASURION/Want-to-Know-More.jpg
// module id = 3744
// module chunks = 0